import React from 'react';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import { init } from './utils/eventTracking';
import { partnerRoutes } from './routes';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import ContactIdRouteInterceptor from './routeInterceptor';

const AppRoutes = () => {
  const routes = useRoutes(partnerRoutes);
  return routes;
};

export default function PartnerApp() {
  React.useEffect(() => {
    init();
  }, []);
  return (
    <BrowserRouter>
      <ContactIdRouteInterceptor />
      <React.Suspense
        fallback={
          <Box
            display='flex'
            justifyContent='center'
            alignItems='center'
            minHeight='100vh'
          >
            <CircularProgress />
          </Box>
        }
      >
        <AppRoutes />
      </React.Suspense>
    </BrowserRouter>
  );
}
